import { MaskedLines } from "./motion";
import { Reveal } from "./motion";

export const PageHeader = ({ eyebrow, lines, sub }) => (
  <section className="pt-40 pb-16 relative noise">
    <div className="container-x">
      <Reveal delay={0} y={16}><p className="eyebrow mb-5">{eyebrow}</p></Reveal>
      <MaskedLines lines={lines} className="max-w-4xl" />
      {sub && (
        <Reveal delay={0.45} y={20}>
          <p className="text-[#A0A3C2] max-w-2xl mt-6 leading-relaxed">{sub}</p>
        </Reveal>
      )}
    </div>
  </section>
);
